package com.evoapps.evoshift.domain.model

enum class UserPermission {
    OWNER,      // Can edit billing, delete workplace, see everything
    MANAGER_FINANCIAL,
    MANAGER,    // Can publish rosters, view sensitive data, approve swaps
    EMPLOYEE;   // Read-only roster, can request swaps, view public profiles only

    // Shorthands kept for existing callers; the rules of who may do what live in Capability.kt.
    fun canViewSensitiveData(): Boolean = can(Capability.MANAGE_PAY)
    fun canApproveSwaps(): Boolean = can(Capability.APPROVE_REQUESTS)
    fun canEditRoster(): Boolean = can(Capability.EDIT_ROSTER)
    /** Working-time reports (ewidencja czasu pracy): managers and the owner. */
    fun canPrintWorkingTime(): Boolean = can(Capability.PRINT_WORKING_TIME)
    /** Payroll and payslips: financial managers and the owner only. */
    fun canPrintPayroll(): Boolean = can(Capability.PAYROLL)
}